<style lang="less">
@import "assets/icon_custom/iconfont.css";
</style>
<style>
  .Menu span {
    color: #ffffff;
    font-weight: bold;
    margin-left: 7%;
  }

  .MenuIcon { 
    margin-left: 7%;
    margin-top: 0.1%;
    color: #252a2f;
  }
.smy__first-menu-box {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 60px;
    background: #252a2f;
    padding-top: 5px; 
    z-index: 9999;
    overflow:auto
}
.smy__second-menu{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 160px;
    background: #eaedf1;
    height: 100%;
}
.smy__second-menu-m{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 160px;
    background: #eaedf1;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}
.smy__box{
    display: flex;
    height: 100%;
}
.first-menu {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 60px;
    height: 50px;
    color: #fff;
    background: #252a2f;
    cursor:pointer;
}
.menu-icon {
    line-height: 22px;
    font-size: 20px;

}
.menu-name {
    margin-top: 5px;
    line-height: 12px;
    font-size: 12px;
}
.logo-text {
    position: fixed;
    top: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    height: 50px;
    font-size: 14px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    box-shadow: 0 2px 6px #ededed;
    z-index: 999;
    width: 160px;
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    background: #252a2f;
    font-weight: bold;
    color: white;
}
.s-menu {
    top: 60px;
    list-style: none;
    color: #515a6e;
    font-size: 12px;
    z-index: 900;
    background: #eaedf1 !important;
}
.s-s-menu {
    list-style: none;
    color: #515a6e;
    font-size: 12px;
    z-index: 900;
    position: fixed;
    background: #eaedf1 !important;
    width: 160px;

}
.smy__first-menu-box .logo {
    margin-top: 15px;
    width: 50px;
    height: 30px;
    background-image: url("/static/w_log.png");
    background-size: 100%;
    background-repeat: no-repeat;
}
.ivu-menu-light {
  background: #eaedf1 !important;
}
</style>
<template>
  <div class="smy__box">
    <div class="smy__first-menu-box">
      <div class="logo"></div>
      <template v-for="item in menuList">
         <div v-if="item.hidden == false" :key="item.name" class="first-menu" @click="changeMain(item.name)">
           <Icon v-if="item.icon.indexOf('iconfont') !== -1" :custom="item.icon" class="menu-icon"/>
           <Icon v-else :type="item.icon" class="menu-icon"></Icon>
           <div class="menu-name">{{ item.title }}</div>
        </div>
      </template>
      <div class="first-menu" @click="changeMain('login')">
        <Icon type="md-log-out" class="menu-icon"></Icon>
        <div class="menu-name">退出</div>
      </div>
    </div>
    <div class="smy__second-menu" style="z-index: 99;" v-if="!hideMenuText">
      <div class="logo-text">{{ $config.title }}</div>
      <div class="smy__second-menu-m">

        <Menu @on-select="currentPageTab" theme=light collapsible=false :active-name="activename"  width="auto" :open-names="openname" style="font-size:13px;" class="s-menu" ref="menu">
          <MenuItem name="home" class="s-s-menu">
            <Icon type="md-home" :size="iconSize"></Icon>
            <span class="layout-text">首页</span>
          </MenuItem>
          <MenuItem name="navigator" class="s-s-menu">
            <Icon type="md-navigate" :size="iconSize"></Icon>
            <span class="layout-text">导航</span>
          </MenuItem>
          <template v-for="item in menuList" class="s-s-menu">
              <template v-for="child in item.children">
                <template v-if="child.hidden == false && child.children && child.children.length == 0 && item.name == name">
                  <MenuItem :name="child.name" :key="child.name"  style="margin-left: 2%">
                    <span class="layout-text" style="font-size:13px;" :key="child.name + 1">{{ child.title }}</span>
                  </MenuItem>
                </template>
                <Submenu v-if="child.hidden == false && child.children && child.children.length>=1 && child.name !== 'main' && item.name == name" :name="child.name" :key="child.path">
                  <template slot="title">
                    <span class="layout-text">{{ child.title }}</span>
                  </template>
                  <template v-for="child in child.children">
                    <template v-if="child.hidden == false && item.name == name">
                      <MenuItem :name="child.name" :key="child.name" style="margin-left: 2%; display: block;">
                        <span class="layout-text" style="font-size:13px;" :key="child.name + 1">{{ child.title }}</span>
                      </MenuItem>
                    </template>
                  </template>
                </Submenu>
              </template>
          </template>
        </Menu>
      </div>
    </div>
  </div>
</template>
<script>
  //
  import axios from 'axios'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'sidebarMenu',
    props: {
      iconSize: Number,
      hideMenuText: false
    },
    data () {
      return {
        menuList: Array,
        name: 'index',
        auth: '',
        openname: [],
        loginuser: '',
        filtermenulist: {
          'ddledit': '',
          'dmledit': '',
          'indexedit': '',
          'serach-mysql': '1',
          'serach-mongodb': '1',
          'serach-redis': '1',
          'serach-kafka': '1',
          'serach-soar': '1',
          'management-user': '',
          'management-database': '',
          'management-cluster': '',
          'audit-audit': '1',
          'audit-record': '1',
          'pod-exec-record': '1',
          'audit-permissions': '1',
          'search_order': '1',
          'query-review': '1',
          'query-audit': '1',
          'setting': '1',
          'task': '1',
          'dns-list': '1',
          'dns-record': '1',
          'dns-history': '1',
          'auth-group': '1',
          'console': '1',
          'deployments': '1',
          'statefulsets': '1',
          'daemonsets': '1',
          'replicasets': '1',
          'jobs': '1',
          'cronjobs': '1',
          'pods': '1',
          'services': '1',
          'endpoints': '1',
          'ingress': '1',
          'configmaps': '1',
          'secrets': '1',
          'nodes': '',
          'namespaces': '',
          'events': '',
          'hosts': '1',
          'domains': '1',
          'admin-users': '1',
          'system-users': '1',
          'cijobs': '1',
          'projects': '1',
          'apps': '1',
          'myorder': '1',
          'ecsorder': '1',
          'virtualservices': '1',
          'gateways': '1',
          'list': '1',
          'env': '1',
          'myapps': '1',
          'dps': '1',
          'sts': '1',
          'cjbs': '1',
          'pds': '1',
          'svcs': '1',
          'domain': '1',
          'chlog': '1',
          'menu': '1'
        },
        activename: ''
      }
    },
    computed: {
      ...mapGetters([
        'permission_routes'
      ]),
      currentPageName () {
        return this.$store.state.currentPageName
      }
    },
    watch: {
      'name': function (val) {
        this.openname = [];
         for (let index = 0; index < this.menuList.length; index++) {
          if (val === this.menuList[index].name) {
             for (let i = 0; i < this.menuList[index].children.length; i++) {
              if (this.menuList[index].children[i].name !== 'cluster' && this.menuList[index].children[i].name !== 'config') {
                this.openname.push(this.menuList[index].children[i].name)
              }
             }
          }
         }
         this.$nextTick(() => {
           this.$refs.menu.updateOpened();
         })
      }
    },
    methods: {
      ...mapActions([
        'getMenu',
        'getMyk8s'
      ]),
      currentPageTab (val) {
        if (this.name !== '' && this.name !== undefined) {
          this.$util.setItem('currentPageName', this.name)
        } else {
          this.$util.setItem('currentPageName', '')
        }
        this.$util.setItem('currentSubName', val)
        this.$util.openPage(this, val)
    },
      changeMain (val) {
          if (val === 'login') {
          this.$util.rmItem('loginuser');
          this.$util.rmItem('jwt');
          this.$util.rmItem('auth');
          this.$util.rmItem('display');
          this.$util.rmItem('avatar');
          this.$util.rmItem('TOKEN');
          localStorage.clear()
          this.$router.push({
            name: 'login'
          })
        } else {
            this.name = val;
        }
      }
    },
    created () {
      this.menuList = this.permission_routes
      this.auth = this.$util.getItem('auth')
      this.name = this.$util.getItem('currentPageName')
      this.activename = this.$util.getItem('currentSubName')
      this.loginuser = this.$util.getItem('loginuser')
      this.getMenu().then(res => {
          let c = res.data
          this.filtermenulist.ddledit = c.ddl
          this.filtermenulist.dmledit = c.dml
          this.filtermenulist.indexedit = c.ddl
          this.filtermenulist['management-user'] = c.user
          this.filtermenulist['management-database'] = c.base
          this.filtermenulist['management-cluster'] = c.k8s
          this.filtermenulist['namespaces'] = c.k8s
          this.filtermenulist['nodes'] = c.k8s
          this.filtermenulist['events'] = c.k8s
      })
      axios.get(`${this.$util.url}/project/myenv`)
      .then(res => {
        this.$util.setItem('my_env_list', JSON.stringify(res.data.data))
      })
      .catch(error => {
        this.$util.error(this, error)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// menu.vue?b5151f38